import '@/lib/typedef';
import client from '@/lib/http-client';

const endpoint = '/background-process';

export default {
	getLast(params, cb, errorCb) {
		const url = `${endpoint}/last`;
		client.get(url, { params })
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},
};
